import {
  Button,
  ListItem as Slot,
  MobileDrawer as Drawer,
  Radio,
  Text,
  Trail,
  Typography,
} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {PaymentCard as PaymentCardItem} from './PaymentCard.mobile'
import {PaymentCardAdd} from './PaymentCardAdd.mobile'
import * as classes from './PaymentCardList.classes'
import {usePaymentCardList} from './PaymentCardList.hooks'
import {Props} from './PaymentCardList.types'

export const PaymentCardList = memo(function PaymentCardList(props: Props): React.ReactElement<Props> {
  const {fetchBindingUrl, onAdd} = props
  const {addDisabled, cards, currentCard, changeHandler, translates, buttonProps, agreementProps} =
    usePaymentCardList(props)

  return (
    <>
      <Slot size="l">
        <Text>
          <Typography thickness="medium" variant="body1">
            {translates.title}
          </Typography>
          <Typography color="minor" mt="xs" variant="caption1">
            {translates.subtitle}
          </Typography>
        </Text>
      </Slot>
      <div />
      {cards.map(c => (
        <PaymentCardItem key={c.id} card={c} checked={c.id === currentCard?.id} onPress={changeHandler} />
      ))}
      {agreementProps && (
        <Slot dividerOffset="m" onPress={agreementProps.onChange} size="l">
          <Text>{agreementProps.children}</Text>
          <Trail mr="m">
            <Radio checked={agreementProps.checked} error={agreementProps.error ? '' : undefined} />
          </Trail>
        </Slot>
      )}
      <PaymentCardAdd disabled={addDisabled} fetchBindingUrl={fetchBindingUrl} onAdd={onAdd} />
      <Drawer.Footer className={classes.footer}>
        <Button {...buttonProps} fullWidth>
          {translates.button}
        </Button>
      </Drawer.Footer>
    </>
  )
})
